export enum CredDefenseStatusEnum {
  AWAITING = "AWAITING",
  REVIEW_DATA = "REVIEW_DATA",
  RECEIVED = "RECEIVED",
  MANUAL_SELFIE_SENT = "MANUAL_SELFIE_SENT",
  EXPIRED = "EXPIRED",
  API_ERROR = "API_ERROR",
  SHOULD_NOT_RUN = "SHOULD_NOT_RUN"
}



// WEBPACK FOOTER //
// ./src/services/Enum/credDefense/CredDefenseStatusEnum.ts